import { makeStyles } from '@material-ui/core';
import React from 'react';
import Up from '../../shared/assets/up.png';

const useStyle = makeStyles({
  imgStyle: {
    height: 50,
    width: 50,
    position: 'absolute',
    '&:hover': {
      transform: 'translateY(-5px)',
      transition: '.5s',
    },
  },
});

export const ArrowTop = () => {
  const classes = useStyle();
  return (
    <div
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      role="button"
      aria-hidden
    >
      <img src={Up} alt="#" className={classes.imgStyle} />
    </div>
  );
};
